import React, { useEffect, useState } from "react";
import TableData from "../../components/ui/Table";
import { useTitle } from "../../components/TitleContext";
import { useFetchTranslation } from "../../hooks/translation/useFetchTranslation";
import Spinner from "../../components/ui/Spinner";
import { getExportTranslationColumns, getExportTranslationHiddenColumns } from "./ExportTranslationColumns";
import Button from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import Icon from "../../components/ui/Icon";
import { useIntegrateServicePack } from "../../hooks/translation/useIntegrateServicePack";
import { Translation } from "../../model/Translation";
import { useConfirmDialog } from "../../hooks/useConfirm";
import { useReExportServicePack } from "../../hooks/translation/useReExportServicePack";
import ExportTranslationCacheName from "../../utils/ExportTranslationCacheName";
import { useQueryClient } from "react-query";
import { useReTranslateTranslation } from "../../hooks/translation/useReTranslateTranslation";
import { useDeleteTranslation } from "../../hooks/translation/useDeleteTranslation";
import { useForceTranslationToReview } from "../../hooks/translation/useForceTranslationToReview";

const ExportServicePack = () => {
  const { setTitle, setSubtitle } = useTitle();
  const navigate = useNavigate();
  const { data: exports, isLoading } = useFetchTranslation();
  const integrateTranslation = useIntegrateServicePack();
  const reExtractTranslation = useReExportServicePack();
  const reTranslate = useReTranslateTranslation();
  const deleteTranslation = useDeleteTranslation();
  const forceTranslationToReview = useForceTranslationToReview();
  const [processingRowIds, setProcessingRowIds] = useState<number>();
  const confirm = useConfirmDialog();
  const queryClient = useQueryClient();
  console.log(exports);

  useEffect(() => {
    setTitle("Extraction & Integration ");
    setSubtitle("");
  }, [setTitle, setSubtitle]);

  const handleIntegrateTranslation = async (translation: Translation) => {
    const productName = translation.product === "5" ? "Fortee" : "Sylob9";
    const confirmIntegration = await confirm({
      title: "Confirm translation integration",
      message:
        "Please confirm the integration the translation of " + productName + "(" + translation.mavenVersion + ")",
    });
    if (!confirmIntegration) return;

    setProcessingRowIds(translation.id);
    integrateTranslation.mutate(
      { translationId: translation.id, productMajorVersion: translation.version },
      {
        onSettled: () => {
          setTimeout(() => {
            setProcessingRowIds(undefined);
          }, 5000);
        },
      }
    );
  };
  const handleReExtractTranslation = (translation: Translation) => {
    reExtractTranslation.mutate({
      translationId: translation.id,
    });
  };
  const handleReTranslateTranslation = async (translation: Translation) => {
    const productName = translation.product === "5" ? "Fortee" : "Sylob9";
    const confirmReTranslate = await confirm({
      title: "Confirm continue translation",
      message:
        "Please confirm you want to continue translatig the " +
        productName +
        "(" +
        translation.mavenVersion +
        "). This operation is irreversible",
    });
    if (!confirmReTranslate) return;
    reTranslate.mutate(translation.id);
  };
  const handleDeleteTranslation = async (translation: Translation) => {
    const productName = translation.product === "5" ? "Fortee" : "Sylob9";
    const confirmDelete = await confirm({
      title: "Confirm delete translation",
      message:
        "Please confirm the delete for the " +
        productName +
        "(" +
        translation.mavenVersion +
        "). This operation is irreversible",
    });
    if (!confirmDelete) return;
    deleteTranslation.mutate(translation.id);
  };

  const handleForceToReviewStatus = async (translation: Translation) => {
    const productName = translation.product === "5" ? "Fortee" : "Sylob9";
    const confirmDelete = await confirm({
      title: "Force Review status",
      message:
        "Please confirm for the " +
        productName +
        "(" +
        translation.mavenVersion +
        ") to force it to review status. This operation is irreversible",
    });
    if (!confirmDelete) return;
    forceTranslationToReview.mutate(translation.id);
  };
  const refreshTranslations = () => {
    queryClient.invalidateQueries(ExportTranslationCacheName.getExportTranslation());
  };

  if (isLoading) return <Spinner />;

  return (
    <>
      <div className="container">
        <div className="flex space-x-4 items-center justify-end">
          <Button variant="secondary" onClick={() => navigate("/export/translation")}>
            <Icon icon="plus">Extract a translation</Icon>
          </Button>
        </div>
        <h1 className=" text-xl font-display font-semibold mb-2">Available Translations</h1>
        <TableData
          tableName="extractionIntegrationTable"
          rows={exports || []}
          columns={getExportTranslationColumns(
            handleIntegrateTranslation,
            handleReExtractTranslation,
            handleReTranslateTranslation,
            handleDeleteTranslation,
            handleForceToReviewStatus
          )}
          pageSize={[25, 50]}
          hiddenColumns={getExportTranslationHiddenColumns()}
          processingRowIds={processingRowIds}
          refreshFunction={refreshTranslations}
        />
      </div>
    </>
  );
};

export default ExportServicePack;
